export default (app) => {
  return {
    namespaced: true,
    state: {
      active: null,
    },
    mutations: {
      setActive(state, v) {
        state.active = v
      },
    },
    actions: {
      setActive(context, v) {
        context.commit('setActive', v)
      },
    },
  }
}
